// /src/auth/useGraphAuth.js
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./msalConfig";

export const useGraphAuth = () => {
    const { instance, accounts } = useMsal();

    const login = async () => {
        try {
            const result = await instance.loginPopup(loginRequest);
            return result.accessToken;
        } catch (error) {
            console.error("Login failed:", error);
        }
    };

    const getToken = async () => {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            return login(); // fallback to popup
        }
    };

    return { login, getToken, account: accounts[0] };
};
